import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'banner' ];

    connect() {
        const cookies = document.cookie
        .split("; ")
        .find((row) => row.startsWith("banner="))
        ?.split("=")[1];

        if(cookies == null) {
            this.bannerTarget.setAttribute('data-group-active', true);
        }
    }

	closeBanner() {
        this.bannerTarget.removeAttribute('data-group-active');

        document.cookie = "banner=closed;";
	}
}